import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  shipmentsTitle: {
    defaultMessage: 'Shipments',
    description: 'fulfillmentSummary.shipments',
    id: 'KSQkge',
  },
  packagesTitle: {
    defaultMessage: 'Packages',
    description: 'fulfillmentSummary.packages',
    id: '3AsUoE',
  },
  noSummary: {
    defaultMessage: 'Select a Ship From and pickup date to retrieve a summary.',
    description: 'fulfillmentPreview.selectPrompt',
    id: 'XndOCh',
  },
  openShipments: {
    defaultMessage: 'Open Shipments',
    description: 'fulfillmentPreview.openShipments',
    id: 'f6mF/1',
  },
  weightUnitPounds: {
    defaultMessage: '{weight, plural, one {Pound} other {Pounds}}',
    description: 'Weight unit in fulfillment preview for pounds',
    id: 'ZYEYbE',
  },
  weightUnitGrams: {
    defaultMessage: '{weight, plural, one {Gram} other {Grams}}',
    description: 'Weight unit in fulfillment preview for grams',
    id: 'hKV1H1',
  },
  weightUnitKilograms: {
    defaultMessage: '{weight, plural, one {Kilogram} other {Kilograms}}',
    description: 'Weight unit in fulfillment preview for Kilograms',
    id: '4zU29c',
  },
});
